import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AppointmentData } from "src/classes/Diary/Appointment";
import { Department, Service } from "src/classes/Diary/DepartmentsServices";
import { HttpServiceDiary } from "src/app/services/Diary/http/http.service_Diary";
import { NGXLogger } from "ngx-logger";
import { registerLocaleData } from "@angular/common";
import localeHe from "@angular/common/locales/he";
import * as moment from "moment";

registerLocaleData(localeHe, "he");

@Component({
    selector: "app-create-app-service",
    templateUrl: "./create-app-service.component.html",
    styleUrls: ["./create-app-service.component.css"]
})
export class CreateAppServiceComponent {
    @Input() appDataTemp: AppointmentData;
    @Input() isEditingEvent: boolean;

    @Output() onServiceToggle = new EventEmitter<Service>();
    @Output() eventTitleChange: EventEmitter<string> = new EventEmitter<string>();

    departments: Department[] = [];
    initialDepartments: Department[] = [];

    state: string = "loading";

    expandedItems: { [item: string]: boolean } = {};

    filterField: string = "";
    // isClearedOnce: boolean = false;

    choosedServices: Service[] = [];

    requiredTime: number = 0;
    maxAvailableTime: number = 0;
    isErrorVisible: boolean = false;

    constructor(
        private httpService: HttpServiceDiary,
        private logger: NGXLogger
    ) { }

    initialize(isLoadingServices: boolean = true): void {
        this.eventTitleChange.emit("בחירת טיפולים");

        this.filterField = "";

        if (isLoadingServices) {
            this.expandedItems = {};

            this.state = "loading";
            this.httpService.getDepartmentsServices(this.appDataTemp)
                .then((data: Department[]) => {
                    if (data !== undefined) {
                        this.departments = [...data];
                        console.log(this.departments)
                        this.initialDepartments = [...data];
                        this.departments.forEach((department: Department) => this.expandedItems[department.id.toString()] = false)

                        this.choosedServices = [...this.appDataTemp.subserv];
                        this.choosedServices.forEach((service: Service) => {
                            this.requiredTime += service.timeService;
                        });

                        this.maxAvailableTime = moment.duration(moment(this.appDataTemp.maxEventEndTime).diff(moment(this.appDataTemp.start as Date))).asMinutes();
                        this.isErrorVisible = this.requiredTime > this.maxAvailableTime;

                        this.departments.forEach((department: Department) => {
                            if (this.hasDepartmentCheckedServices(department)) {
                                this.expandedItems[department.id.toString()] = true;
                            }
                        });

                        this.filterDepartments();
                    }
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
                });
        }
        else {
            this.maxAvailableTime = moment.duration(moment(this.appDataTemp.maxEventEndTime).diff(moment(this.appDataTemp.start as Date))).asMinutes();
            this.isErrorVisible = this.requiredTime > this.maxAvailableTime;
            this.filterDepartments();
        }
        // this.isClearedOnce = false;
    }

    // Disable controls while loading data
    isControlsDisabled(): boolean {
        return this.state == "loading";
    }

    // (???)
    // Disable controls when clients have not been loaded
    isFiltersDisabled(): boolean {
        return this.state == "noclients";
    }

    // Function that returns data for data table
    filterDepartments(): void {
        this.departments = JSON.parse(JSON.stringify(this.initialDepartments));

        const filteredDepartments: Department[] = this.departments.filter((department: Department) => {
            // if (this.filterField != "") {
            //     this.isClearedOnce = false;
            // }
            // else {
            //     this.expandedItems[department.id.toString()] = false;
            //     this.isClearedOnce = true;
            // }

            if (this.filterField.trim() == "") {
                this.expandedItems[department.id.toString()] = false;
                return true;
            }

            if (department.name.toLocaleLowerCase().includes(this.filterField.toLocaleLowerCase().trim())) {
                return true;
            }

            const filteredServices = department.services.filter((service: Service) => service.serviceName.toLocaleLowerCase().includes(this.filterField.toLocaleLowerCase().trim()));
            if (filteredServices.length) {
                this.expandedItems[department.id.toString()] = true;

                department.services = filteredServices;

                return true;
            }

            return false;
        });

        if (this.initialDepartments.length === 0) {
            this.state = "nodepartments";
        }
        else if (filteredDepartments.length === 0) {
            this.state = "noresults";
        }
        else {
            this.state = "loaded";
        }

        this.departments = filteredDepartments;
    }

    // Returns true if departament has choosed services
    hasDepartmentCheckedServices(department: Department): boolean {
        let isDepartmentChecked: boolean = false;

        department.services.forEach((service: Service) => {
            if (isDepartmentChecked) {
                return;
            }

            isDepartmentChecked = this.isServiceChecked(service);
        });

        return isDepartmentChecked;
    }

    // Returns true if service is choosed
    isServiceChecked(service: Service): boolean {
        return this.choosedServices.map((service: Service): number => service.serviceId).includes(service.serviceId);
    }

    // On departament expand function 
    onStripExpand(department: Department): void {
        this.expandedItems[department.id.toString()] = !this.expandedItems[department.id.toString()];
    }

    // Function that choose services
    toggleService(service: Service): void {
        if (this.isServiceChecked(service)) {
            this.choosedServices.splice(this.choosedServices.findIndex((tempService: Service) => tempService.serviceId == service.serviceId), 1);
        }
        else {
            this.choosedServices.push(service);
        }

        this.requiredTime = 0;

        this.choosedServices.forEach((tempService: Service) => {
            this.requiredTime += tempService.timeService;
        });

        this.isErrorVisible = this.requiredTime > this.maxAvailableTime;

        this.onServiceToggle.emit(service);
    }
}
